import React, { Component } from 'react'
import AntTable from "antd/lib/table";
import Input from "antd/lib/input";
import Icon from "antd/lib/icon"
import Button from "antd/lib/button"
import AntTree from "antd/lib/tree"

import Highlighter from 'react-highlight-words';

import datas from "./data.json"
import { DefCol } from "./ColDef";

const {
    TreeNode
} = AntTree;

/**
 * 动态列组件
 */
export class DynamicColTable extends Component<DynamicColTableProps, {
    showcols: any[],
    datas: any[],
    searchText: string,
    searchedColumn: string,
}> {

    constructor(props) {
        super(props)
        this.setDefCols(props.defcols)

        if (this.props.getDatas) {
            this.props.getDatas(0, 1, {}, this.getedDataSource)
        }

        this.setColSelectList()
        this.state = {
            showcols: this.getShowCols(this.props.defcols),
            datas: this.props.dataSource ? this.props.dataSource : [],
            searchText: '',
            searchedColumn: '',
        }
    }

    setColSelectList() {
        if (!this.allColsWithVisibleStatus || this.allColsWithVisibleStatus.length == 0) {
            this.props.defcols.forEach((element) => {
                if (element.isShow == '1' && !element.isFilterCol && !element.fixed
                    && !element.hidden) {
                    this.checkedColKeys.push(element.fieldCode);
                }
                this.allColsWithVisibleStatus.push(element)
            });
            // $params.tableHead = plainOptionsList;
        }
    }
    setDefCols(cols: DefCol[]) {
        cols.map(element => {
            Object.assign(element,
                {
                    title: element.fieldName,
                    dataIndex: element.fieldCode,
                    key: element.fieldCode,
                    ellipsis: true,
                    align: 'center',
                    width: element.hidden ? 0 : 120,
                },
                this.getColumnSearchProps(element),
                this.getColFilterProps(element),
                element)
        })
    }

    checkedColKeys: any[] = []
    allColsWithVisibleStatus: DefCol[] = []
    getColFilterProps(element: DefCol): any {
        if (element.isFilterCol) {
            return {
                filterDropdown: ({
                    confirm,
                    clearFilters
                }) => (
                        <div style={{
                            padding: 8,
                            height: 400
                        }}>
                            <AntTree
                                checkable={true}
                                className="draggable-tree"
                                draggable={true}
                                blockNode={true}
                                selectable={false}
                                onCheck={this.onCheck}
                                checkedKeys={this.checkedColKeys}
                                onDrop={this.onDrop}
                                style={{
                                    height: 350,
                                    overflow: "auto"
                                }}>
                                {this.getTreeSelectCols(this.allColsWithVisibleStatus)}
                            </AntTree>
                        </div >
                    ),

                filterIcon: filtered => (<Icon
                    type="setting"
                    theme="filled"
                />),
                onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange
            }
        } else {
            return {}
        }
    }
    // 数据列选择
    getTreeSelectCols = (data: any[]) => {
        let nodes: any[] = []
        data.map((element, index) => {
            if (!element.isFilterCol && !element.fixed && !element.hidden) {
                nodes.push((<TreeNode key={element.key} title={element.title}></TreeNode>))
            }
        })
        return nodes;
    };

    editPlainOptions: any[] = [];
    editCheckedOptions: any[] = [];
    isClickHandleSearch = false;//设置字段后在未保存的情况下点击空白区域字段重置

    onFilterDropdownVisibleChange = (visible, type) => {
        if (visible && !this.isClickHandleSearch) {
            this.isClickHandleSearch = false;
        } else {

        }
    };

    onCheck = (checkedKeys) => {
        this.allColsWithVisibleStatus.forEach((el, index) => {
            if (!this.isAlwaysShowCol(el)) {
                el.isShow = false
                checkedKeys.forEach(function (checkedKey) {
                    // 是选中的
                    if (el.key === checkedKey) {
                        el.isShow = true;
                    }
                });
            }
        });
        let showCols = this.getShowCols(this.allColsWithVisibleStatus)
        this.setState({
            showcols: showCols
        })
        this.checkedColKeys = [].concat(checkedKeys);
    };

    isAlwaysShowCol(col: DefCol) {
        // hidden is a width 0 
        if (col.isFilterCol || col.fixed || col.hidden) {
            return true;
        } else {
            return false;
        }
    }

    onDrop = (info) => {
        const dropKey = info.node.props.eventKey;
        const dragKey = info.dragNode.props.eventKey;
        const dropPos = info.node.props.pos.split("-");
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);

        if (dropPosition === 1 || dropPosition == -1) {
            const loop1 = function (data, key, callback) {
                data.forEach(function (item, index, arr) {
                    if (item.key === key) {
                        return callback(item, index, arr);
                    }
                    if (item.children) {
                        return loop1(item.children, key, callback);
                    }
                });
            };

            const data = this.allColsWithVisibleStatus;
            let dragObj;
            loop1(data, dragKey, function (item, index, arr) {
                arr.splice(index, 1);
                dragObj = item;
            });
            let ar;
            let i;
            loop1(data, dropKey, function (item, index, arr) {
                ar = arr;
                i = index;
            });

            if (dropPosition === -1) {
                ar.splice(i, 0, dragObj);
            } else {
                ar.splice(i + 1, 0, dragObj);
            }
            this.allColsWithVisibleStatus = ([] as any).concat(data);

            let datas = new Array();
            // if (noAddColOne) {
            //     datas.push(showcolumns[0]);
            //     noAddColOne = false;
            // }
            data.forEach((r, index) => {
                this.props.defcols.forEach((rs) => {
                    if (r.key == rs.key) {
                        this.checkedColKeys.forEach(function (ck) {
                            if (rs.key == ck) {
                                datas.push(rs);
                            }
                        });
                    }
                });
            });
            this.setState({
                showcols: data
            })
        }
    };


    getedDataSource = (datas, index, pagesize, cond) => {
        setTimeout(() => {
            this.setState({
                datas: datas
            })
        });
    }

    getShowCols(cols: DefCol[]): any[] {
        let newCols: any[] = []
        cols.forEach(el => {
            if (el.sortDirections != undefined && el.sorter == undefined) {
                // 默认的sorter
                el.sorter = function (a, b, sortDirection) {
                    let valuea = a[this.fieldCode];
                    let valueb = b[this.fieldCode];
                    if (valuea != undefined && valueb != undefined) {
                        return valuea.localeCompare(valueb)
                    } else if (valuea == undefined) {
                        return 1;
                    } else if (valueb == undefined) {
                        return -1;
                    }
                }
            }
            let col = Object.assign({}, el)
            if (el.isShow && el.isShow !== '0') {
                newCols.push(col)
            }
        })
        return newCols;
    }

    searchInput: any
    getColumnSearchProps = colDef => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`查找 ${colDef.fieldName}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, colDef)}
                    style={{ width: 168, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm, colDef)}
                    icon="search"
                    size="small"
                    style={{ width: 80, marginRight: 8 }}>
                    查询
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 80 }}>
                    重置
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) => {
            if (record[colDef.dataIndex]) {
                return record[colDef.dataIndex].toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
            } else {
                return false
            }
        },
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text =>
            (this.state.searchedColumn === colDef && text) ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                    text
                ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    render() {
        const props: any = Object.assign({
            columns: this.state.showcols,
            dataSource: this.state.datas,
            pagination: this.props.pagination,
            bordered: true,
            locale: { sortTitle: '排序', filterTitle: '筛选', filterConfirm: '确定', filterReset: '重置' },
            size: "middle",
            scroll: {
                // x: 'calc(700px + 50%)',
                x: 1200,
                // y: 240
            },
            rowKey: 'id',
        }, this.props)
        return (
            <AntTable
                {...props}
            ></AntTable>
        )
    }
}

/**
 * 列定义
 */
export interface DynamicColTableProps {
    /**
     * 列定义数组
     */
    defcols: DefCol[],
    /**
     * 获取数据回调
     * @param {number} index 页码 从1开始
     * @param {number} pagesize 分页大小
     * @param {Object} cond  查询条件
     * @param {function} callback 设置数据回调
     */
    getDatas?: (index: number, pagesize, cond, callback) => void,
    /**
     * 数据源数组
     */
    dataSource?: any[]
    /** 是否分页 */
    pagination: boolean | any,
    /** 其他 */
    [key: string]: any
}

/**
 * 列定义
 */
export interface getDataSource {
    /** prop1 description */
    (index, pagesize, cond, callback): void
}


// export class DynamicColTabletsDemo extends Component {

//     getDataSource: getDataSource = (index, size, cond, callback) => {
//         callback(datas.data)
//     }

//     render() {
//         return (
//             <DynamicColTable size="small" defcols={datas.colum} getDatas={this.getDataSource} pagination={false}>

//             </DynamicColTable>
//         )
//     }
// }
